import React, { useEffect, useState } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { List, Button, Anchor } from 'antd';
import dayjs from 'dayjs';
import './ListTurns.scss';
import { useSelector } from 'react-redux';
import Modal from '../../Modal/Modal';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import NewTurnForm from '../NewTurnForm/NewTurnForm';
dayjs.extend(utc);
dayjs.extend(timezone);

export default function ListTurns(props) {
  const {
    slots,
    turnUser,
    turns,
    setReload,
    turnId,
    size,
    turnType,
    date,
    loadingParent,
    doctorData,
    setTurnDetail,
  } = props;
  const [isVisibleModal, setIsVisibleModal] = useState(false);
  const [modalTitle, setModalTitle] = useState('');
  const [modalContent, setModalContent] = useState(null);

  const { tenantTimezone } = useSelector((store) => store.tenantData);

  useEffect(() => {
    setIsVisibleModal(false);
  }, [turnUser]);

  async function addTurn(turn) {
    setIsVisibleModal(true);
    setModalTitle(
      <p>
        {dayjs(date).format('dddd')} {dayjs(date).format('D')} de{' '}
        {dayjs(date).format('MMMM')}{' '}
        {dayjs(turn?.hourStart).tz(tenantTimezone).format('HH mm')} hs
      </p>
    );
    setModalContent(
      <NewTurnForm
        date={date}
        scheduleConfig={doctorData?.scheduleConfig}
        turnId={turnId}
        turnUser={turnUser}
        turnType={turnType}
        hourStart={turn?.hourStart}
        turns={turns}
        doctor={doctorData}
        setIsVisibleModal={setIsVisibleModal}
        size={turn?.sizeSlot || size}
        setTurnDetail={setTurnDetail}
      />
    );
  }

  return (
    <div className="turns-list">
      <Anchor offsetTop={5}>
        <h3 className="title-date">
          {dayjs(date).format('dddd')} {dayjs(date).format('D')} de{' '}
          {dayjs(date).format('MMMM')}
        </h3>
      </Anchor>
      <p
        style={{
          textAlign: 'center',
          fontSize: '12pt',
          color: 'grey',
        }}
      >
        {slots?.length > 0 ? 'Seleccione un horario' : 'Agenda completa'}
      </p>
      <List
        grid={{ gutter: 16, xs: 4 }}
        dataSource={slots}
        size="small"
        renderItem={(slot, index) => (
          <List.Item>
            <div className="turns-list__date">
              <Button onClick={() => addTurn(slot)}>
                <span>
                  {dayjs(slot?.hourStart).tz(tenantTimezone).format('HH:mm')}
                </span>
              </Button>
            </div>
          </List.Item>
        )}
        locale={{ emptyText: 'No hay más turnos, intente otro día.' }}
        loading={
          loadingParent && {
            style: { width: '100%' },
            size: 'large',
            indicator: <LoadingOutlined />,
          }
        }
      />

      <Modal
        title={modalTitle}
        isVisible={isVisibleModal}
        setIsVisible={setIsVisibleModal}
        width={modalTitle === 'Cancelar turno' ? '50%' : '90%'}
      >
        {modalContent}
      </Modal>
    </div>
  );
}
